import { OlCourseResultScoreType } from '@modules/types/graphql';

export const resultScoreTypeTranslates = {
    [OlCourseResultScoreType.in_100]: 'common:blocks.course_result_score_type.in_100',
    [OlCourseResultScoreType.in_5]: 'common:blocks.course_result_score_type.in_5',
    [OlCourseResultScoreType.origin]: 'common:blocks.course_result_score_type.origin',
};

export const resultScoreTypeOptions = Object.entries(resultScoreTypeTranslates).map(
    ([type, value]) => ({
        key: type,
        value,
    }),
);
